import Services from '../../services';

export default class Service extends Services {
  //
}
